<template>
  <div v-if="friend" class="modal">
    <div class="underlay underlay--modal" @click="closeModal" />
    <div class="scroll">
      <picture>
        <source
          srcset="@/assets/images/village/scroll.webp 700w"
          type="image/webp"
          sizes="50vw"
        >
        <img
          class="scroll__background"
          alt="Scroll"
          src="@/assets/images/village/scroll.png"
          srcset="@/assets/images/village/scroll.png 700w"
          width="744"
          height="499"
          sizes="50vw"
        >
      </picture>
      <div class="scroll__inner">
        <a class="scroll__close pagelink" @click="closeModal">
          <img alt="Close" src="@/assets/images/icons/close.svg" width="29" height="29">
        </a>
        <div class="scroll__title flex-row">
          <img
            v-if="friend.AvatarUrl"
            alt="Avatar"
            :src="friend.AvatarUrl"
            class="scroll__avatar"
          >
          <span v-if="friend.Title">
            {{ friend.Title }}
          </span>
        </div>
        <p>
          <b>
            Their Story
          </b>
        </p>
        <p
          v-if="friend.Bio"
          v-html="outputText(friend.Bio)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',

  props: {
    friend: {
      default: () => {},
      type: Object
    }
  },
  methods: {
    closeModal () {
      this.$gtm.trackEvent({
        'event': 'Close Friend Read More'
      })
      this.$store.dispatch('setModal', null)
    },
    outputText (str) {
      return str.replace(/(?:\r\n|\r|\n)/g, '<br>')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.modal {
  position: absolute;
  z-index: 6;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.underlay--modal {
  background-color: $black;
  opacity: .6;
}
.scroll {
  z-index: 1;
  width: 550px;
  padding: 70px 20px;
}
.scroll__close {
  top: 5px;
}
.scroll__background {
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
}
.scroll__title {
  margin-bottom: 20px;
}
.scroll__avatar {
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  background-color: $white;
  border: 2px solid $brown;
  margin-right: 10px;
}
</style>
